var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-switch',{staticClass:"app-switch",class:{
              'app-switch--pink': _vm.isPinkTheme,
              'app-switch--reverse': _vm.reverse,
           },attrs:{"value":_vm.value,"disabled":_vm.disabled,"width":30,"active-text":_vm.text},on:{"input":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }